import { createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../services/instance";
import { endpoints } from "../../constants/endpoints";

export const getRequests = createAsyncThunk("getRequests", async (id) => {
  try {
    const response = await instance.get(endpoints.getRequest(id));
    return response;
  } catch (error) {
    return {
      exception: error,
    };
  }
});

export const requestStatus = createAsyncThunk("requestStatus", async (data) => {
  try {
    const response = await instance.post(endpoints.requestStatus, data);
    return response;
  } catch (error) {
    return {
      exception: error,
    };
  }
});

export const rescheduleRequest = createAsyncThunk(
  "rescheduleRequest",
  async (data) => {
    try {
      const response = await instance.post(endpoints.rescheduleRequest, data);
      return response;
    } catch (error) {
      return {
        exception: error,
      };
    }
  }
);
